import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  deliveryCharges: [],
  categoryList: [],
};

export const deliverySlice = createSlice({
  name: "delivery Charges",
  initialState,
  reducers: {
    setDeliveryCharges: (state, action) => {
      state.deliveryCharges = action.payload;
    },
    setCategoryList: (state, action) => {
      state.categoryList = action.payload;
    },
  },
});

export const { setDeliveryCharges, setCategoryList } = deliverySlice?.actions;
